module.exports = __webpack_public_path__ + "static/media/auth-wrapper.e62cbbe4.jpg";